<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 status">
  @if (_active) {
    <kendo-window
      #mainWindow
      title="{{ _pageState == 2 ? 'ADD NEW RECORD' : _pageState == 3 ? 'EDIT RECORD' : _pageState == 1 ? 'VIEW RECORD' : _pageState == 4 ? 'EDIT FIELDS MODE' : '' }}"
      (close)="_closeForm()"
      (stateChange)="_onStateChanges($event)"
      class="fullWidthFormForm"
      [class.editFieldsModeClass]="_pageState == 4"
      [class.disabledPopup]="_editFormActive || _orderingTabsForm || _deactivatedFieldsForm"
      (keydown.enter)="$event.preventDefault()">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0 border_sections">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 row m-0 p-0">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 p-0">
              <h2 class="formsTitle">Funding Source
                @if (canAccess(_permissionScope, 'update')) {
                  <span
                    (click)="_edit()"
                    [class.ViewModeVisibleElement]="_pageState == 1"
                    class="action-button action-button-viewMode">
                    <div class="action-button-icon">
                      <img src="/assets/menu/enterprise/edit-action-icon-grid.svg"/>
                    </div>
                    <div class="edit-icon-text">Edit</div>
                  </span>
                }
              </h2>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 row m-0 p-0 d-block">
              <div class="upsert-header-buttons">
                @if (_pageState != 1) {
                  <div>
                    <button kendoButton class="steps_buttons_class" (click)="_onCancel()">
                      <img class="backimage" [src]="'/assets/menu/'+ _theme +'/close-schedule-report-icon-green.svg'"/>
                      <span>close</span>
                    </button>
                    @if (canAccess(_permissionScope, 'create')) {
                      <button kendoButton
                        class="steps_buttons_class"
                        [disabled]="_pageState == 4 ? true : false"
                        (click)="_onSave('saveAndCopy')">
                        <img class="backimage"
                          [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                          <span>save & Copy</span>
                        </button>
                      }
                      @if (canAccess(_permissionScope, 'create')) {
                        <button kendoButton
                          class="steps_buttons_class"
                          [disabled]="_pageState == 4 ? true : false"
                          (click)="_onSave('saveAndNew')">
                          <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                          <span>save & New</span>
                        </button>
                      }
                      <button kendoButton
                        class="steps_buttons_class"
                        [disabled]="_pageState == 4 ? true : false"
                        (click)="_onSave('saveAndClose')">
                        <img class="backimage"
                          [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                          <span>save & Close</span>
                        </button>
                        <button kendoButton
                          class="steps_buttons_class"
                          [disabled]="_pageState == 4 ? true : false"
                          (click)="_onSave('save')">
                          <img class="backimage"
                            [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'"/>
                            <span>save</span>
                          </button>
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <div class="col-12 p-0">
                  <div class="formsMenuSeparator"></div>
                </div>
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-4 mb-4">
                  <fieldset class="col-12"
                    [class.col-6-imp]="_pageState == 1 || _pageState == 2 || _pageState == 3 || _pageState == 4">
                    <div class="form-group from_but_container special_style_formgroup margin-top-10">
                      <label for="statusId" class="control-label">
                        {{getLabel("LBL_FundingSourceId")?.currentText}}
                      </label>
                      <input #kendo_BarcodeGen_Status_StatusId
                        [class.ViewModeDisabledControl]="_pageState == 1"
                        type="text"
                        [attr.disabled]="(_pageState == 2 || _pageState == 3) ? null : 'disabled'"
                        [disabled]="(_pageState == 2 || _pageState == 3) ? false : true"
                        class="k-textbox writebox min-width-0 newFormControlWidth"
                        [placeholder]="$safeNavigationMigration(getLabel('LBL_FundingSourceId')?.currentText)"
                        [(ngModel)]="fundingSourceId"
                        [ngModelOptions]="{standalone: true}"
                        required/>
                        <!-- <a class="cursor-pointer"
                        [class.ViewModeHiddenElement]="_pageState == 1 || _pageState == 4"
                        (click)="_generateBarcodeClick()">
                        <img
                          class="searchIcon"
                          [src]="'/assets/menu/'+ _theme +'/auto-generate-icon.svg'"
                        /></a> -->
                        <!--  <a
                        [class.editfieldsIconvisible]="_pageState == 4"
                        class="editFieldsIcon"
                        (click)="_openRenameForm('LBL_StatusId', true)"
                        >
                        <img
                          class="searchIcon"
                          [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'"
                        /></a> -->
                      </div>
                      <div class="form-group special_style_formgroup">
                        <label for="description" class="control-label">
                          {{getLabel("LBL_FundingSourceDescription")?.currentText}}
                        </label>
                        <input #kendo_Input_Dispose_Description
                          [class.ViewModeDisabledControl]="_pageState == 1"
                          type="text"
                          [attr.disabled]="(_pageState == 2 || _pageState == 3) ? null : 'disabled'"
                          [disabled]="(_pageState == 2 || _pageState == 3) ? false : true"
                          class="k-textbox writebox newFormControlWidth"
                          [placeholder]="$safeNavigationMigration(getLabel('LBL_FundingSourceDescription')?.currentText)"
                          [(ngModel)]="description"
                          [ngModelOptions]="{standalone: true}"
                          [attr.required]="getLabel('LBL_FundingSourceDescription')?.isRequired ? 'required' : null"/>
                          <!-- <a
                          [class.editfieldsIconvisible]="_pageState == 4"
                          class="editFieldsIcon"
                          (click)="_openRenameForm('LBL_FundingSourceDescription')"
                          ><img
                          class="searchIcon"
                          [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'"
                        /></a> -->
                      </div>
                    </fieldset>
                  </div>
                </div>
                <!-- Tabs and Fields -->
                <div class="example-wrapper">
                  <div class="row no_row_margin">
                    <div [ngClass]="{'col-md-8': !_currentUser.isEnterprise,'col-md-12':_currentUser.isEnterprise}"
                      class="responsive_style numericboxtab" [class.ossystem]="_isOs" #kendo_tabstrip_wrapper>
                      @if ((_dataTabs && _dataTabs.length > 1) || _currentUser.isEnterprise) {
                        <kendo-tabstrip (tabSelect)="_onTabSelect($event)" [tabPosition]="_kendoTabStripPosition"
                          #kendo_tabstrip>
                          <!-- Accounts Tab -->
                          @if (_currentUser && _currentUser.isEnterprise) {
                            <kendo-tabstrip-tab
                              #accountTab title="Accounts"
                              [selected]="_currentUser && _currentUser.isEnterprise">
                              <ng-template kendoTabContent>
                                <div class="greytabtop menumobilecontainer">
                                  <img class="mobiletabIcon"
                                    (click)="_mobileMenuToggle()"
                                    [src]="'/assets/menu/'+ _theme +'/fields-menu-icon.svg'"/>
                                  </div>
                                  <div class="tabcontent tabWizGridInside accountTab"
                                    [class.active]="_addClassActive">
                                    <asap-account-sites-selection
                                      [class.ViewModeDisabledControl]="_pageState == 1"
                                      [disabled]="_pageState == 1"
                                      [selectedAccounts]="_selectedAccounts"
                                      [enableSiteSelection]="false"
                                      [resolver]="_getAccounts"
                                      (onRowSelectionChanges)="_onAccountRowSelectionChanges($event)">
                                    </asap-account-sites-selection>
                                  </div>
                                </ng-template>
                              </kendo-tabstrip-tab>
                            }
                          </kendo-tabstrip>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="example-wrapper">
                    <div class="row no_row_margin">
                      <div class="col-8"></div>
                      <div class="col-4 col-lg-4 col-xl-4 responsive_style">
                        @if (!_currentUser.isEnterprise) {
                          <div
                            class="borderedNotesContainer">
                            <note #note
                              [_pageState]="_pageState"
                              [_model]="_model"
                              [_page]="_page">
                            </note>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </kendo-window>
            }
          </div>
